export default "__VITE_ASSET__1fcc10a3__"